import { render, staticRenderFns } from "./CompletedFormsGrid.vue?vue&type=template&id=edce9c22"
import script from "./CompletedFormsGrid.vue?vue&type=script&lang=js"
export * from "./CompletedFormsGrid.vue?vue&type=script&lang=js"
import style0 from "./CompletedFormsGrid.vue?vue&type=style&index=0&id=edce9c22&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports